<script>
  export default {
    data() {
      return {
        ano: (new Date()).getFullYear(),
      }
    },
    methods: {
    }
  }
</script>

<style>
  .simulacao {  
    width: 90%;
    padding: 10px 10px;
    display: flex;
    justify-content: center;
    align-content: center;
  }
</style>

<template>
  <div class="text-center loginscreen animated fadeInDown simulacao" >
    <div>
      <div>
        <h1 class="logo-name">
          <img src="/img/logo.png" alt="logo">
        </h1>
      </div>
      
      <router-view></router-view>
      
      <p class="m-t text-white"> <small>Manager &copy; {{ ano }} </small> </p>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/LayoutSimulacao.vue